type DeviceType = 'mobile' | 'tablet' | 'desktop';

type Browser =
  | 'chrome'
  | 'edge'
  | 'firefox'
  | 'safari'
  | 'opera'
  | 'ie'
  | 'unknown';

const getDeviceType = (): DeviceType => {
  const ua = navigator.userAgent;
  if (
    ua.indexOf('iPhone') > 0 ||
    ua.indexOf('iPod') > 0 ||
    (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
  ) {
    return 'mobile';
  }
  if (
    ua.indexOf('iPad') > 0 ||
    ua.indexOf('Android') > 0 ||
    (ua.indexOf('Safari') > 0 &&
      ua.indexOf('Chrome') === -1 &&
      typeof document.ontouchstart !== 'undefined')
  ) {
    return 'tablet';
  }
  return 'desktop';
};

const getBrowserFromUserAgentData = (): Browser | undefined => {
  const userAgentData = navigator.userAgentData;
  if (userAgentData) {
    const brands = userAgentData.brands.map(({ brand }) => brand);
    if (brands.includes('Google Chrome')) {
      return 'chrome';
    }
    if (brands.includes('Microsoft Edge')) {
      return 'edge';
    }
    if (brands.includes('Opera')) {
      return 'opera';
    }
  }
  return undefined;
};

const getBrowserFromUserAgent = (): Browser => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1) {
    return 'ie';
  }
  if (ua.indexOf('edge') !== -1) {
    return 'edge';
  }
  if (ua.indexOf('edg') !== -1) {
    return 'edge';
  }
  if (ua.indexOf('chrome') !== -1) {
    return 'chrome';
  }
  if (ua.indexOf('safari') !== -1) {
    return 'safari';
  }
  if (ua.indexOf('firefox') !== -1) {
    return 'firefox';
  }
  if (ua.indexOf('opera') !== -1) {
    return 'opera';
  }
  return 'unknown';
};

export const getBrowserInfo = (): {
  deviceType: DeviceType;
  browser: Browser;
} => ({
  deviceType: getDeviceType(),
  browser: getBrowserFromUserAgentData() || getBrowserFromUserAgent(),
});
